// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"20727":"18c49a5149530a7d","24397":"1c73507c785b0a55","36556":"c90a9aafffb5b66e","40103":"440766797b3e56ec","74706":"f828c2e112845c3b","96217":"9e5544203774da6b"}[chunkId] + ".css";
};